import { types as t } from "../mutations/flow";

export const types = {
  ADD_FLOW_ITEM: "ADD_FLOW_ITEM",
  REMOVE_FLOW_ITEM: "REMOVE_FLOW_ITEM",
  CLEAR_FLOW: "CLEAR_FLOW"
};

export const actions = {
  [types.ADD_FLOW_ITEM]: ({ commit }, item) => commit(t.M_ADD_FLOW_ITEM, item),
  [types.REMOVE_FLOW_ITEM]: ({ commit }, uuid) =>
    commit(t.M_REMOVE_FLOW_ITEM, uuid),
  [types.CLEAR_FLOW]: ({ commit }) => commit(t.M_CLEAR_FLOW)
};
